import { render } from "./withdraw2.vue?vue&type=template&id=7cd5538b&scoped=true"
import script from "./withdraw2.vue?vue&type=script&lang=js"
export * from "./withdraw2.vue?vue&type=script&lang=js"

import "./withdraw2.vue?vue&type=style&index=0&id=7cd5538b&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd5538b"]])

export default __exports__